<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue" @cancel="preventLeavingWithUnsavedChanges">
        <!-- USERNAME -->
        <FormGroupNew :label="__('integrations.bliggit.config.label.username')"
                      :description="__('integrations.bliggit.config.description.username')"
                      :error="config.errors.bliggit_username"
                      :required="requiredFields.includes('bliggit_username')">
            <input type="text" class="form-control" v-model="config.bliggit_username">
        </FormGroupNew>

        <!-- PASSWORD -->
        <FormGroupNew :label="__('integrations.bliggit.config.label.password')"
                      :description="__('integrations.bliggit.config.description.password')"
                      :error="config.errors.bliggit_password"
                      :required="requiredFields.includes('bliggit_password')">
            <PasswordInput v-model="config.bliggit_password"/>
        </FormGroupNew>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import Errors from "@components/Errors.vue";
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import ToggleModel from '@components/ToggleModel.vue'
import PasswordInput from "@components/Form/PasswordInput.vue";
import FormErrors from "@components/Form/FormErrors.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {
        FormGroupNew,
        FormErrors,
        PasswordInput,
        ToggleModel,
        IntegrationStoreSettingsLayout,
        Errors
    },

    mixins: [IntegrationStoreConfigMixin],
}
</script>
